import type { TFullUnit, UnitData } from './types.no-deps'
import { flatMap, values } from 'lodash'

/**
 * The picked out attributes from unit.data that will be relevant for a report
 */

export type CachedUnitData = CachedUnitDatum[]

export interface CachedUnitDatum {
    unitId: number
    attributeName: string
    value: string | number
}

export function cachedUnitDatum(unitId: number, attributeName: string, value: string | number): CachedUnitDatum {
    return { unitId, attributeName, value }
}

export function getDataForUnit(cachedUnitData: CachedUnitData, unitId: number) {
    const unitData: UnitData = {}

    for (const datum of cachedUnitData) {
        if (datum.unitId !== unitId) continue
        unitData[datum.attributeName] = datum.value
    }

    return unitData
}

export class CachedUnitDataBuilder {
    private cache: Record<number, Record<string, CachedUnitDatum>> = {}

    push(unit: Pick<TFullUnit, 'id' | 'data'>, attributeName: string) {
        const value = unit.data[attributeName]
        if (value == null) return

        this.cache[unit.id] ||= {}

        if (this.cache[unit.id][attributeName]?.value === value) return

        this.cache[unit.id][attributeName] = cachedUnitDatum(unit.id, attributeName, value)
    }

    build() {
        return flatMap(values(this.cache), values)
    }
}
